import React, { memo } from "react";
import styles from "./BpsAdminHeader.module.scss";
import { MenuIcon } from "../../../assets/icons";
import LandingUserInfoDropdown from "../../../common/components/user-info-dropdown/LandingUserInfoDropDown";

type Props = {
	onMenuClick: () => void;
};

const BpsAdminHeader: React.FC<Props> = memo((props: Props) => {
	const { onMenuClick } = props;

	return (
		<div className={styles.container}>
			<button title="Menu" className={styles.menuButton} onClick={onMenuClick}>
				<MenuIcon />
			</button>
			<LandingUserInfoDropdown />
		</div>
	);
});

export default BpsAdminHeader;
